// eslint-disable-next-line import/no-unresolved
const translator = require('./dist/client/translator');

module.exports = translator;
